module.exports = __webpack_public_path__ + "static/media/badgeIcon.fa848a85.svg";